module.exports = __webpack_public_path__ + "static/img/step2.38fcd25d.webp";